import BaseClass from "../BaseClass.js";

export default class ConversationSearch extends BaseClass {
    constructor(element) {
        super(element);
        this.openConversationSearchListener = null;
        this.conversationId = null;
        this.searchRequested = false;

        this.$searchInputContainer = null;
        this.$activateSearchButton = null;

        this.$resetSearchButton = null;
        this.$closeSearchButton = null;
        this.$searchInputBar = null;
        this.$searchButton = null;

        this.init();
    }

    init() {
        let mySelf = this;

        this.conversationId = this.$element.attr('data-target-id');

        this.$searchInputContainer = this.$element.find('[data-type="search-input-container"]');
        this.$activateSearchButton = this.$element.find('[data-type="conversation-search-button"]');

        this.$resetSearchButton = this.$searchInputContainer.find('[data-type="clear-conversation-search"]');
        this.$closeSearchButton = this.$searchInputContainer.find('[data-type="close-conversation-search"]');
        this.$searchInputBar = this.$searchInputContainer.find('[data-type="conversation-search-bar"]');
        this.$searchButton = this.$searchInputContainer.find('[data-type="conversation-search-btn"]');

        // die Suche schließen, Konversation neu laden, wenn eine Suche durchgeführt wurde
        this.$closeSearchButton.on('click', function () {
            mySelf.$searchInputContainer.addClass('hidden');
            mySelf.$activateSearchButton.removeClass('hidden');
            mySelf.$searchInputBar.val('');

            if (mySelf.searchRequested) {
                mySelf.resetSearch();
            }
        });

        // die Suche zurücksetzen, Konversation neu laden, wenn eine Suche durchgeführt wurde
        this.$resetSearchButton.on('click', function () {
            mySelf.$searchInputBar.val('').focus();

            if (mySelf.searchRequested) {
                mySelf.resetSearch();
            }
            mySelf.searchRequested = false;
        });

        this.$searchButton.on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            let searchSequence = mySelf.$searchInputBar.val().trim();

            if (searchSequence != "") {
                mySelf.submitSearch(searchSequence);
            }
        });

        this.$searchInputBar.on('keypress', function (e) {
            if (e.which == 13) {
                let searchSequence = $(this).val().trim();

                if (searchSequence != "") {
                    mySelf.submitSearch(searchSequence);
                }
            }
        });

        this.openConversationSearchListener = function (event) {
            mySelf.handleConversationSearch();
        }

        this.$activateSearchButton.on('click', this.openConversationSearchListener);
    }

    handleConversationSearch() {
        let mySelf = this;

        if (this.$searchInputContainer.hasClass('hidden')) {
            this.$searchInputContainer.removeClass('hidden');
            this.$activateSearchButton.addClass('hidden');
            this.$searchInputBar.focus();
            this.searchRequested = false;
        } else {
            this.$searchInputContainer.addClass('hidden');
            this.$activateSearchButton.removeClass('hidden');
            this.$searchInputBar.val('');

            if (this.searchRequested) {
                mySelf.resetSearch();
            }
        }
    }

    resetSearch() {
        const enhancedEvent = {
            conversationId: this.conversationId
        };
        $(document).trigger('conversation:reset_search', enhancedEvent);
    }

    submitSearch(searchSequence) {
        this.searchRequested = true;
        const enhancedEvent = {
            conversationId: this.conversationId,
            searchSequence: searchSequence
        };
        $(document).trigger('conversation:submit_search', enhancedEvent);
    }

    destroyListener() {
        this.$element.off('click', this.openConversationSearchListener);
    }
}